const initialState = {
  disposableModals: null,
};

const reducers = {
  clearDisposableModals(state) {
    state.disposableModals = null;
  },
};

const matchers = [
  [
    ({ type }) => type === 'requests/get-modals/fulfilled',
    (state, { payload: { modals } = {} }) => {
      state.disposableModals = modals ?? [];
    },
  ],
];

export const disposableModalsSegment = {
  initialState,
  reducers,
  matchers,
};
